import { validate as uuidValidate, version as uuidVersion, v4 as uuidv4 } from 'uuid';

import { isRNWebview } from 'constants/constants';

// uuid cause issues with jest. YOU ARE WARNED !
export const getDeviceId = () => {
  const mobileDeviceId = localStorage.getItem('mobileDeviceId');
  if (isRNWebview() && mobileDeviceId) {
    return mobileDeviceId;
  }
  let deviceId = localStorage.getItem('deviceId');

  if (deviceId && uuidValidate(deviceId) && uuidVersion(deviceId) === 4) {
    return deviceId;
  }

  deviceId = uuidv4();
  localStorage.setItem('deviceId', deviceId);

  return deviceId;
};
